import styled, { css } from 'styled-components';
import Icon from '../../_shared/components/Icon';
import Button from '../../_shared/components/Button';
import Heading from '../../_shared/components/Heading';

export const SearchIcon = styled(Icon).attrs({
  icon: 'TR5-Search_magnify'
})`
  width: 24px;
  height: 24px;
`;

export const OmpSearchIcon = styled(Icon).attrs({
  icon: 'TR5-OMP-Search_magnify'
})`
  width: 18px;
  height: 18px;
`;

export const ModalOuterBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  z-index: 100;
  margin: auto;
  background-color: ${({ theme, showingResults }) =>
    showingResults ? theme.COLORS.BASE : theme.COLORS.TRANSPARENT};
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  z-index: 10;
  top: ${({ isOmp }) => (isOmp ? '18px' : '36px')};
  right: ${({ isOmp }) => (isOmp ? '-8px' : '36px')};
  width: 88px;
  height: 30px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  border: 2px solid
    ${({ theme, isOmp }) =>
      isOmp ? theme.COLORS.BASE : theme.COLORS.BASE_INVERTED};
  border-radius: 4px;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
  margin-left: 9px;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${({ theme, isOmp }) =>
      isOmp ? theme.COLORS.BASE : theme.COLORS.BASE_INVERTED};
    color: ${({ theme }) => theme.COLORS.BASE};
    path {
      stroke: ${({ theme, isOmp }) =>
        isOmp ? theme.COLORS.BASE_INVERTED : theme.COLORS.BASE};
      stroke-width: 4px;
    }
  }
`;
ModalCloseButton.Icon = styled(Icon).attrs({
  icon: 'TR5-Close_X'
})`
  width: ${({ isOmp }) => (isOmp ? '12px' : '10px')};
  height: ${({ isOmp }) => (isOmp ? '12px' : '10px')};
  margin-left: 4px;
  path {
    stroke: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    stroke-width: 2px;
  }
`;

const OmpModalInnerBox = css`
  padding: 48px 36px 12px;
`;

export const ModalInnerBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${({ showingResults }) => (showingResults ? '948px' : '1100px')};
  padding: ${({ showingResults }) =>
    showingResults ? '24px 36px 0px 36px' : '48px 36px'};
  background-color: ${({ theme }) => theme.COLORS.BASE};
  justify-content: center;
  align-items: flex-start;
  border-radius: 3px;
  ${props => props.isOmp && OmpModalInnerBox}
`;

export const ModalSearchTitleWrapper = styled.div`
  display: flex;
`;

export const ModalSearchTitle = styled.div`
  display: flex;
  text-decoration-line: ${({ underlined }) =>
    underlined ? 'underline' : 'none'};
  margin-right: ${({ underlined }) => (underlined ? '0px' : '8px')};
  font-family: ${({ underlined, theme }) =>
    underlined ? theme.FONT.REGULAR : theme.FONT.LIGHT};
  font-size: ${({ theme }) => theme.FONT_SIZES.XXLARGE};
  color: ${({ underlined, theme }) =>
    underlined ? theme.COLORS.TERTIARY : theme.COLORS.BASE_INVERTED};
  height: 35px;
  &:hover {
    cursor: ${({ underlined }) => (underlined ? 'pointer' : 'default')};
  }
`;
export const ModalDropdownIconWrapper = styled.div`
  position: relative;
  top: -5px;
`;
export const ModalDropdownIcon = styled(Icon).attrs({
  icon: 'TR5-Dropdown'
})`
  width: 24px;
  height: 12px;
`;

export const ModalSearchAreaWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 20px;
  margin-left: 0;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  ${({ applyPadding }) =>
    applyPadding &&
    css`
      padding: 0 16px;
    `}
  ${({ isOmpSearchBarOnly }) =>
    isOmpSearchBarOnly &&
    css`
      background-color: inherit;
      margin-top: 0;
      padding: 0;
    `}
`;

export const SearchInputWrapper = styled.div`
  display: block;
  position: relative;
  flex-basis: 80%;
  flex-grow: 2;
  flex-shrink: 2;
  max-width: 1100px;
`;

export const ModalSearchIconWrapper = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 8px;
`;

const OmpModalInputField = css`
  border-bottom: ${({ theme, showingResults }) =>
    showingResults
      ? `2px solid ${theme.COLORS.BASE_INVERTED}`
      : `1px solid ${theme.COLORS.NEUTRAL_100}`};
`;

export const ModalInputField = styled.input`
  text-indent: 35px;
  height: 40px;
  min-width: 200px;
  max-width: 1100px;
  width: 100%;
  border: 0;
  outline: 0;
  border-bottom: ${({ theme, showingResults }) =>
    showingResults
      ? `2px solid ${theme.COLORS.BASE_INVERTED}`
      : `2px solid ${theme.COLORS.NEUTRAL_50}`};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
  ::placeholder {
    font-family: ${({ theme }) => theme.FONT.LIGHT};
    font-size: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
    color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  }
  ${props => props.isOmp && OmpModalInputField}
  ${({ isOmpSearchBarOnly }) =>
    isOmpSearchBarOnly &&
    css`
      background-color: inherit;
      ::placeholder {
        color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
      }
    `}
`;

export const ModalSearchButton = styled(Button.Primary)`
  position: relative;
  min-width: 120px;
  height: 48px;
  font-size: 18px;
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  border: 3px solid ${({ theme }) => theme.COLORS.BASE};
  border-radius: 6px;
  padding: 5px;
  margin: auto 0 auto 18px;
  ${({ isOmpSearchBarOnly }) =>
    isOmpSearchBarOnly &&
    css`
      font-size: 14px;
      font-family: ${({ theme }) => theme.FONT.BOLD};
      height: 40px;
      letter-spacing: 0;
      text-transform: lowercase;
      &:first-letter {
        text-transform: capitalize;
      }
      &:hover {
        background-color: ${({ theme }) => theme.COLORS.DARK_BLUE};
      }
    `}
`;

export const ModalHintWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 80px;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
`;

export const KeyIcon = styled.div`
  width: ${({ esc }) => (esc ? '31px' : '24px')};
  height: 22px;
  background: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  color: ${({ theme }) => theme.COLORS.BASE};
  border-radius: 3px;
  margin: 0 6px;
  padding-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:after {
    content: '';
    width: calc(100% - 4px);
    height: 2px;
    background: ${({ theme }) => theme.COLORS.BASE};
    position: absolute;
    bottom: 1px;
    left: 2px;
    border-radius: 0 0 4px 4px;
    border-top: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_20};
  }
`;
const overlayFirstChildStyle = css`
  & ul li:first-child {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
    font-style: normal;
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    text-decoration: none;
    &:hover {
      cursor: default;
      background-color: ${({ theme }) => theme.COLORS.BASE};
    }
  }
`;
export const ModalOverlayWrapper = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  min-width: ${({ isSearchHistory }) => (isSearchHistory ? '360px' : '180px')};
  overflow: auto;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  line-height: 36px;
  & ul {
    margin-top: ${({ isSearchHistory }) => (isSearchHistory ? '10px' : '4px')};
    margin-bottom: ${({ isSearchHistory }) =>
      isSearchHistory ? '10px' : '4px'};
  }
  ${({ isSearchHistory }) => isSearchHistory && overlayFirstChildStyle};
  & ul li {
    text-indent: 25px;
    display: block;
    color: ${({ isSearchHistory, theme }) =>
      isSearchHistory ? theme.COLORS.TERTIARY : theme.COLORS.BASE_INVERTED};
    font-style: ${({ isSearchHistory }) =>
      isSearchHistory ? 'italic' : 'normal'};
    font-family: ${({ theme }) => theme.FONT.REGULAR};
    font-size: ${({ isSearchHistory, theme }) =>
      isSearchHistory ? theme.FONT_SIZES.SMALL : theme.FONT_SIZES.BASE};
    text-decoration-line: ${({ isSearchHistory }) =>
      isSearchHistory ? 'underline' : 'none'};
    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.COLORS.NEUTRAL_5};
    }
  }
`;
export const SearchResultWrapper = styled.div`
  margin: 24px auto 24px auto;
  background-color: ${({ isOmp, theme }) =>
    isOmp ? theme.COLORS.NEUTRAL : theme.COLORS.NEUTRAL_60};
  width: 900px;
`;
export const StyledHeading = styled(Heading)`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin: ${({ theme }) => theme.FONT_SIZES.MEDIUM};
`;
export const FooterLabel = styled.div`
  display: block;
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  line-height: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.LIGHT};
  text-align: center;
  padding-bottom: 11px;
  margin-top: 24px;
`;
